// extracted by mini-css-extract-plugin
module.exports = {"container":"_3c6ef300a5--container--LykER","header":"_3c6ef300a5--header--oATy3","content":"_3c6ef300a5--content--b1Trf","footer":"_3c6ef300a5--footer--ewbA8"};